// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("./role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");

function empty(param) {
  return {
          role: Role$ReactHooksTemplate.empty(),
          email: /* [] */0
        };
}

function addEmail(t, email) {
  return {
          role: t.role,
          email: email
        };
}

function addRole(t, role) {
  return {
          role: role,
          email: t.email
        };
}

function role(t) {
  return t.role;
}

function roleId(t) {
  return Role$ReactHooksTemplate.id(t.role);
}

function email(t) {
  return t.email;
}

function toJson(t) {
  var encodeEmails = List.length(t.email) > 1 ? Belt_Array.map(Belt_List.toArray(t.email), (function (x) {
            return Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, x);
          })) : Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, List.hd(t.email));
  var encodeRole = Role$ReactHooksTemplate.id(t.role) === 0 ? [] : [Role$ReactHooksTemplate.id(t.role)];
  return Json_encode.object_({
              hd: [
                "email",
                encodeEmails
              ],
              tl: {
                hd: [
                  "roles",
                  encodeRole
                ],
                tl: /* [] */0
              }
            });
}

var InviteUserParams = {
  empty: empty,
  addEmail: addEmail,
  addRole: addRole,
  role: role,
  roleId: roleId,
  email: email,
  toJson: toJson
};

function reducer(state, action) {
  switch (action.TAG) {
    case "Roles" :
        return {
                roles: action._0,
                user: state.user,
                notification: state.notification
              };
    case "UpdateUser" :
        return {
                roles: state.roles,
                user: action._0,
                notification: state.notification
              };
    case "AddNotification" :
        return {
                roles: state.roles,
                user: state.user,
                notification: action._0
              };
    
  }
}

var initialState_user = {
  role: Role$ReactHooksTemplate.empty(),
  email: /* [] */0
};

var initialState = {
  roles: /* [] */0,
  user: initialState_user,
  notification: undefined
};

function InviteUser(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var fetchRoles = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/roles", (function (param) {
                  return Json_decode.field("roles", (function (param) {
                                return Json_decode.list(Role$ReactHooksTemplate.decode, param);
                              }), param);
                }));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (roles) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "Roles",
                                  _0: roles
                                }));
                }), fetchRoles());
        }), []);
  var validateEmail = function (email) {
    var emailRegex = new RegExp("^[^\s@]+@[^\s@]+\.[^\s@]+$");
    return emailRegex.test(email);
  };
  var emailPresentInList = function (email) {
    return Belt_List.has(state.user.email, email, Caml_obj.equal);
  };
  var handleRoleChange = function (email) {
    var selectedRole = List.hd(List.filter(function (y) {
                return Role$ReactHooksTemplate.name(y) === email;
              })(state.roles));
    var addRole$1 = addRole(state.user, selectedRole);
    Curry._1(dispatch, {
          TAG: "UpdateUser",
          _0: addRole$1
        });
  };
  var alertType = state.notification;
  var options = List.map(Role$ReactHooksTemplate.name, state.roles);
  var roleName = Role$ReactHooksTemplate.name(state.user.role);
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                        alertType: alertType,
                        handleClose: (function (param) {
                            Curry._1(dispatch, {
                                  TAG: "AddNotification",
                                  _0: undefined
                                });
                          })
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: "Invite by email",
                            className: "py-2 border-b-2 border-pigmentblue text-sm font-semibold"
                          }),
                      className: "w-100-px"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Email",
                                      className: "block text-sm mb-px font-medium",
                                      name: "email"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        $$Array.of_list(Belt_List.mapWithIndex(Belt_List.keepWithIndex(state.user.email, (function (param, index) {
                                                        return index < 2;
                                                      })), (function (index, email) {
                                                    return JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx("p", {
                                                                        children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email),
                                                                        className: "text-sm font-normal"
                                                                      }),
                                                                  JsxRuntime.jsx("button", {
                                                                        children: JsxRuntime.jsx("img", {
                                                                              className: "w-2 ml-2",
                                                                              src: Image$ReactHooksTemplate.closeIcon
                                                                            }),
                                                                        className: "text-gray-500 hover:text-gray-700 focus:outline-none",
                                                                        style: {
                                                                          outline: "None"
                                                                        },
                                                                        onClick: (function (param) {
                                                                            var updatedList = Belt_List.keepWithIndex(state.user.email, (function (param, i) {
                                                                                    return i !== index;
                                                                                  }));
                                                                            var newUsers = addEmail(state.user, updatedList);
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "UpdateUser",
                                                                                  _0: newUsers
                                                                                });
                                                                          })
                                                                      })
                                                                ],
                                                                className: "flex items-center bg-cultured pl-1 pr-3 rounded-md h-24-px"
                                                              });
                                                  }))),
                                        JsxRuntime.jsx("input", {
                                              className: "flex border-none outline-none text-sm h-38-px rounded-lg px-2 w-full ",
                                              id: "user_email",
                                              name: "user[email]",
                                              placeholder: List.length(state.user.email) === 0 ? "Type email addresses to invite teammates" : "",
                                              type: "text",
                                              onKeyDown: (function ($$event) {
                                                  var key = $$event.key;
                                                  if (!(key === "," || key === " " || key === "Enter")) {
                                                    return ;
                                                  }
                                                  $$event.preventDefault();
                                                  var inputElement = $$event.target;
                                                  var email = inputElement.value.trim();
                                                  var emailPresent = emailPresentInList(Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, email)) === false;
                                                  if (!(validateEmail(email) && emailPresent)) {
                                                    return ;
                                                  }
                                                  var newList = Belt_List.add(state.user.email, Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, email));
                                                  var createParams = addEmail(state.user, newList);
                                                  Curry._1(dispatch, {
                                                        TAG: "UpdateUser",
                                                        _0: createParams
                                                      });
                                                  inputElement.value = "";
                                                }),
                                              onBlur: (function ($$event) {
                                                  var inputElement = $$event.target;
                                                  var email = inputElement.value.trim();
                                                  var emailPresent = emailPresentInList(Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, email)) === false;
                                                  if (!(validateEmail(email) && emailPresent)) {
                                                    return ;
                                                  }
                                                  var newList = Belt_List.add(state.user.email, Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, email));
                                                  var createParams = addEmail(state.user, newList);
                                                  Curry._1(dispatch, {
                                                        TAG: "UpdateUser",
                                                        _0: createParams
                                                      });
                                                  inputElement.value = "";
                                                })
                                            })
                                      ],
                                      className: "flex border border-gray-300 rounded-lg bg-white h-40-px items-center p-2 gap-1"
                                    })
                              ],
                              className: "flex-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Assign Role",
                                      className: "block text-sm mb-px font-medium",
                                      name: "email"
                                    }),
                                JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                      options: options,
                                      placeholder: roleName !== "" ? roleName : "Select Role",
                                      handleChange: handleRoleChange,
                                      selectedOptions: /* [] */0,
                                      className: " h-40-px border border-gray-300 outline-none p-2 w-full rounded-lg mb-1 bg-white ",
                                      optionsHoverColor: "hover:bg-ghostwhiteblue rounded-lg ",
                                      listBoxCss: "p-1 rounded-lg "
                                    })
                              ],
                              className: "w-40"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("button", {
                                    children: "Invite User",
                                    className: (
                                      Belt_List.length(state.user.email) === 0 ? "cursor-not-allowed" : ""
                                    ) + " float-right rounded-lg w-100-px bg-pigmentblue text-white h-32-px",
                                    disabled: Belt_List.length(state.user.email) === 0,
                                    onClick: (function (param) {
                                        var emails = state.user.email;
                                        var url = List.length(emails) > 1 ? "/api/v1/invitations/bulk_create" : "/api/v1/invitations";
                                        var payload = toJson(state.user);
                                        Js_promise.then_((function (response) {
                                                var isBulk = List.length(emails) > 1;
                                                var match;
                                                if (isBulk) {
                                                  var resultDecoder = function (param) {
                                                    return Json_decode.tuple3((function (param) {
                                                                  return Json_decode.field("email", Json_decode.string, param);
                                                                }), (function (param) {
                                                                  return Json_decode.field("success", Json_decode.bool, param);
                                                                }), (function (param) {
                                                                  return Json_decode.optional((function (param) {
                                                                                return Json_decode.field("errors", (function (param) {
                                                                                              return Json_decode.list(Json_decode.string, param);
                                                                                            }), param);
                                                                              }), param);
                                                                }), param);
                                                  };
                                                  var results = Json_decode.field("results", (function (param) {
                                                          return Json_decode.list(resultDecoder, param);
                                                        }), response);
                                                  var failed = List.filter(function (param) {
                                                          return param[1] === false;
                                                        })(results);
                                                  var errorMsg = List.length(failed) > 0 ? Js_array.joinWith("; ", Belt_List.toArray(List.map((function (param) {
                                                                    var errors = param[2];
                                                                    return param[0] + ": " + (
                                                                            errors !== undefined ? Js_array.joinWith(", ", Belt_List.toArray(errors)) : "Unknown error"
                                                                          );
                                                                  }), failed))) : "Couldn't invite the user(s)";
                                                  match = [
                                                    List.length(failed) === 0,
                                                    errorMsg
                                                  ];
                                                } else {
                                                  var success = Json_decode.field("success", Json_decode.bool, response);
                                                  var errors = Json_decode.optional((function (param) {
                                                          return Json_decode.field("errors", (function (param) {
                                                                        return Json_decode.list(Json_decode.string, param);
                                                                      }), param);
                                                        }), response);
                                                  var errorMsg$1 = errors !== undefined ? Js_array.joinWith(", ", Belt_List.toArray(errors)) : "Couldn't invite the user";
                                                  match = [
                                                    success,
                                                    errorMsg$1
                                                  ];
                                                }
                                                if (match[0]) {
                                                  window.location.reload();
                                                } else {
                                                  Curry._1(dispatch, {
                                                        TAG: "UpdateUser",
                                                        _0: {
                                                          role: Role$ReactHooksTemplate.empty(),
                                                          email: /* [] */0
                                                        }
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: "AddNotification",
                                                        _0: {
                                                          TAG: "Failure",
                                                          _0: match[1]
                                                        }
                                                      });
                                                }
                                                return Promise.resolve();
                                              }), Http$ReactHooksTemplate.fetchPostEncodedJSON(url, payload));
                                      })
                                  }),
                              className: "w-full"
                            })
                      ],
                      className: "flex flex-wrap gap-4 my-20-px w-full"
                    })
              ],
              className: "bg-ghostwhiteblue p-16-px rounded-lg h-5/9"
            });
}

var make = InviteUser;

exports.InviteUserParams = InviteUserParams;
exports.reducer = reducer;
exports.initialState = initialState;
exports.make = make;
/* initialState Not a pure module */
